// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Zona de arrastrar y soltar para subir un fichero.
 *
 * Vive aparte de \`lists.css\` porque no es un control de listado: lo usan las
 * pantallas de administración que publican artefactos. Solo tokens del design
 * system, para que funcione igual con cualquier skin.
 */

.file-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 16px 14px;
  border: 2px dashed var(--border, rgba(255, 255, 255, 0.18));
  border-radius: var(--radius-md, 10px);
  background: var(--bg-surface, transparent);
  color: var(--text-secondary, rgba(255, 255, 255, 0.65));
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.file-drop:hover,
.file-drop:focus-visible {
  border-color: var(--accent, #6366f1);
  color: var(--text-primary, #e2e8f0);
  outline: none;
}

/* Mientras se arrastra encima: mismo borde de acento y un fondo tenue. */
.file-drop--over {
  border-color: var(--accent, #6366f1);
  background: rgba(var(--accent-rgb, 99, 102, 241), 0.08);
  color: var(--text-primary, #e2e8f0);
}

.file-drop__icon {
  width: 22px;
  height: 22px;
  opacity: 0.75;
}

.file-drop__title {
  font-weight: 600;
  font-size: 0.9rem;
  word-break: break-all;
}

.file-drop__hint {
  font-size: 0.78rem;
  color: var(--text-muted, rgba(255, 255, 255, 0.45));
}

/* El input sigue existiendo (de ahí salen \`files\` y el click), pero no se ve. */
.file-drop__input {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/file-drop.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2DAA2D;EAC3D,qCAAqC;EACrC,0CAA0C;EAC1C,uDAAuD;EACvD,eAAe;EACf,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;;EAEE,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,oCAAoC;EACpC,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,gFAAgF;AAChF;EACE,aAAa;AACf","sourcesContent":["/**\r\n * Zona de arrastrar y soltar para subir un fichero.\r\n *\r\n * Vive aparte de `lists.css` porque no es un control de listado: lo usan las\r\n * pantallas de administración que publican artefactos. Solo tokens del design\r\n * system, para que funcione igual con cualquier skin.\r\n */\r\n\r\n.file-drop {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding: 16px 14px;\r\n  border: 2px dashed var(--border, rgba(255, 255, 255, 0.18));\r\n  border-radius: var(--radius-md, 10px);\r\n  background: var(--bg-surface, transparent);\r\n  color: var(--text-secondary, rgba(255, 255, 255, 0.65));\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.file-drop:hover,\r\n.file-drop:focus-visible {\r\n  border-color: var(--accent, #6366f1);\r\n  color: var(--text-primary, #e2e8f0);\r\n  outline: none;\r\n}\r\n\r\n/* Mientras se arrastra encima: mismo borde de acento y un fondo tenue. */\r\n.file-drop--over {\r\n  border-color: var(--accent, #6366f1);\r\n  background: rgba(var(--accent-rgb, 99, 102, 241), 0.08);\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.file-drop__icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  opacity: 0.75;\r\n}\r\n\r\n.file-drop__title {\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  word-break: break-all;\r\n}\r\n\r\n.file-drop__hint {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted, rgba(255, 255, 255, 0.45));\r\n}\r\n\r\n/* El input sigue existiendo (de ahí salen `files` y el click), pero no se ve. */\r\n.file-drop__input {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
